import React, { useEffect, useCallback, useMemo } from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Navbar from "components/common/Navbar";
import Footer from "components/common/Footer";
import Landing from "components/Landing/Landing";
import HowItWorks from "components/HowItWorks/HowItWorks";
import AboutUs from "components/AboutUs/AboutUs";
import Pricing from "components/Pricing/Pricing";
import Blogs from "components/Blog/Blogs";
import Blog from "components/Blog/Blog";
import TermsAndConditions from "./components/termsandconditions/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
// import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import BlogDetail from "components/Blog/BlogDetail";
import WhyZerodha from "./components/Blog/why_zerodha";
import WhyInteractive from "./components/Blog/why_interactive_brokers";
import Profile from "components/Authentication/Profile";
import { logout } from "actions/auth";
import "./App.css";
import Performance from "./components/Performance/Performance";
import Dashboard from "components/Dashboard/Dashboard";
import Broker from "components/Broker/Broker";
import DcaPage from "./components/DCA/DcaPage";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import ContactUs from "components/ContactUs/ContactUs";
import { showLogin } from "actions/ui_control";
// TEST PAGE!!!
//Health Page
import HealthComponent from "./components/ELBHealth/health";
import ScrollToTop from "components/common/ScrollToTop";
import Modals from "components/common/layout/Modals";

const App = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.auth);

  // const { user: userData } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const next = searchParams.get("next");

    if (next) {
      if (isLoggedIn) {
        navigate(next);
        return;
      }

      const showLoginParam = searchParams.get("show_login");
      if (showLoginParam) dispatch(showLogin());
    }
  }, [location.search, dispatch, navigate]);

  // The function returns true if path matches specific pages where the theme color should be dark.
  const pathname = location.pathname;

  const isShowDarkTheme = () => {
    // Array of paths where the theme color should be dark.
    const darkThemePages = ["/performance", "/brokers", "/dca"];
    // Take the last character and remove if it is === '/'
    const last = pathname.charAt(pathname.length - 1);

    const path =
      last === "/" ? pathname.slice(0, pathname.length - 1) : pathname;
    // check if current path matches any value of the darkThemePages array

    return darkThemePages.find((pagePath) => pagePath === path);
  };
  const isShowLightContainer = useMemo(() => {
    // Array of paths where the theme color should be dark.
    const alwaysLightTheme = ["/contact-us"];
    // Take the last character and remove if it is === '/'
    const last = pathname.charAt(pathname.length - 1);

    const path =
      last === "/" ? pathname.slice(0, pathname.length - 1) : pathname;
    // check if current path matches any value of the darkThemePages array

    return alwaysLightTheme.find((pagePath) => pagePath === path);
  }, [pathname]);

  const logOut = useCallback(async () => {
    await dispatch(logout());
    navigate("/");
  }, [dispatch, navigate]);
  const isDarkTheme = (isLoggedIn || isShowDarkTheme()) && pathname !== "/";
  return (
    // isShowDarkTheme returns true if path matches specific page. Added exception for the landing page
    <div className={isDarkTheme ? "dark-theme" : "light-theme"}>
      <ScrollToTop />
      <Modals />
      <Navbar
        logout={logOut}
        isLoggedIn={isLoggedIn}
        user={user}
        isDarkTheme={isDarkTheme}
      />
      <Container
        fluid
        className={`p-md-0 full-page ${
          isShowLightContainer ? "container-light" : ""
        }`}
      >
        <Routes>
          <Route exact path="/" element={<Landing />} />
          <Route exact path="/how-it-works" element={<HowItWorks />} />
          <Route exact path="/about-us" element={<AboutUs />} />
          <Route exact path="/pricing" element={<Pricing />} />
          <Route exact path="/terms" element={<TermsAndConditions />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/blog" element={<Blogs />} />
          <Route path="/blog/:blogTitle" element={<Blog />} />

          <Route
            exact
            path="/blog/a-personal-letter-from-our-ceo"
            element={<BlogDetail />}
          />
          <Route
            exact
            path="/blog/why-interactive-brokers"
            element={<WhyInteractive />}
          />
          <Route exact path="/blog/why-zerodha" element={<WhyZerodha />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/profile" element={<Profile />} />
          <Route exact path="/performance" element={<Performance />} />
          <Route exact path="/brokers" element={<Broker />} />
          <Route exact path="/dca" element={<DcaPage />} />
          <Route exact path="/contact-us" element={<ContactUs />} />
          <Route path="*" element={<ErrorPage />} />
          <Route exact path="/health" element={<HealthComponent />} />
        </Routes>
      </Container>
      <Footer
        isLoggedIn={isLoggedIn}
        isDarkTheme={isLoggedIn || isShowDarkTheme()}
      />
    </div>
  );
};

export default App;
